<template>
  <div class="main">

    <my_menu2 page_name="项目列表" back_type="close" back_icon="md-close"></my_menu2>
    <div style="height:40px">

    </div>

    <div class="content">
      <div class="options_div">
        <div class="options_inner">
          <div class="select_item">
            <Cascader size="small" style="font-size: 10px" :data="dep_options" placeholder="筛选部门" v-model="select_dep"
              v-width="200" @on-change="cascader_change" />

            <Select @on-change="operation_status_change" size="small" v-model="operation_status_index"
              style="width: 100px; margin-left: 10px">
              <Option v-for="item in operation_status_list" :value="item.value" :key="item.value">{{ item.label }}
              </Option>
            </Select>
          </div>

          <Input clearable @on-search="search" v-model="project_name" style="width: 200px; margin-left: 10px"
            size="small" @on-clear="search" search enter-button placeholder="按名称搜索" />

          <Input clearable @on-search="search" v-model="kefu_name" style="width: 200px; margin-left: 10px" size="small"
            @on-clear="search" search enter-button placeholder="按客服搜索" />
        </div>

        <div>
          <Button size="small" type="primary" style="font-size: 12px" @click="click_add_project()">
            <Icon type="ios-add" size="14" style="margin-right: 3px" />新增项目
          </Button>
        </div>
      </div>

      <div class="table_box">
        <Spin fix size="large" v-if="table_loading"></Spin>

        <Table size="small" :height="windowHeight - 130" :columns="columns" :data="project_list">
          <template #project_name="{ row }">
            <div class="project_name">
              <div class="project_type_name" :style="'background:' + row.project_type_color">
                {{ row.project_type_name }}
              </div>

              <span class="project_name2" @click="update_project_click(row)">{{
                row.project_name
              }}</span>
            </div>
          </template>
          <template #project_group_name="{ row }">
            <span>{{ row.project_group_name }}

              <Icon @click="editor_group(row)" class="editor_group_name" type="ios-create-outline" />
            </span>
          </template>
          <template #operation_status="{ row }">
            <span class="operation_status_span" v-if="row.operation_status == 0">正常</span>

            <span class="operation_status_span2" v-if="row.operation_status == 1">停止</span>
          </template>

          <template #authority="{ row }">
            <Button size="small" style="font-size: 12px" @click="click_project_manage(row)">
              <Icon type="ios-contacts" size="14" style="margin-right: 5px" />权限管理
            </Button>
          </template>
        </Table>
        <div class="page_div">
          <Page @on-change="page_change" :total="total_count" :page-size="limit" v-model="page" show-total />
        </div>
      </div>
    </div>
    <Drawer title="权限更新" :closable="true" v-model="project_auth_show" width="90">
      <project_auth ref="project_auth"></project_auth>
    </Drawer>

    <Modal v-model="update_group_show" title="更新项目组" :footer-hide="true">
      <Select v-model="update_project_group_id" style="width: 450px" filterable clearable>
        <Option v-for="item in group_list" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>
      <div class="button_add_project">
        <Button :loading="add_loading" type="primary" @click="update_group_name_confirm">确认添加</Button>
      </div>
    </Modal>

    <Modal v-model="add_project_show" title="新增项目" :footer-hide="true">
      <div class="add_project_box">
        <div class="project_add_field">
          <div class="project_add_title">所属项目组：</div>
          <Select filterable v-model="add_group_project_id" style="width: 400px">
            <Option v-for="item in group_data" :value="item.value" :key="item.value">{{ item.label }}
            </Option>
          </Select>
        </div>
        <div class="project_add_field">
          <div class="project_add_title">项目类型：</div>
          <Select filterable v-model="add_type_id" style="width: 400px">
            <Option v-for="item in type_options" :value="item.value" :key="item.value">{{ item.label }}
            </Option>
          </Select>
        </div>
        <div class="project_add_field">
          <div class="project_add_title">项目主体：</div>
          <Select clearable filterable v-model="project_subject_id" style="width: 400px">
            <Option v-for="item in subject_data" :value="item.subject_id" :key="item.subject_id">{{
              item.company_short_name
            }}
            </Option>
          </Select>
        </div>
        <div class="project_add_field">
          <div class="project_add_title">项目名称：</div>
          <Input v-model="add_project_name" placeholder="输入项目名称" style="width: 400px" />
        </div>
        <div class="project_add_field">
          <div class="project_add_title">部门：</div>
          <Cascader filterable :data="dep_options" v-model="dep_list" v-width="400" />
        </div>
      </div>
      <div class="button_add_project">
        <Button :loading="add_loading" type="primary" @click="add_project_ok">确认添加</Button>
      </div>
    </Modal>

    <Modal v-model="update_project_show" title="更新项目" :footer-hide="true">
      <div class="add_project_box">
        <div class="project_add_field">
          <div class="project_add_title">所属项目组：</div>
          <Select filterable v-model="current_update_project_data.project_group_id" style="width: 400px">
            <Option v-for="item in group_data" :value="item.value" :key="item.value">{{ item.label }}
            </Option>
          </Select>
        </div>
        <div class="project_add_field">
          <div class="project_add_title">项目类型：</div>
          <Select filterable v-model="current_update_project_data.project_type" style="width: 400px">
            <Option v-for="item in type_options" :value="item.value" :key="item.value">{{ item.label }}
            </Option>
          </Select>
        </div>
        <div class="project_add_field">
          <div class="project_add_title">项目简称：</div>
          <Input clearable v-model="current_update_project_data.project_name" placeholder="输入项目名称"
            style="width: 400px" />
        </div>
        <div class="project_add_field">
          <div class="project_add_title">项目全称：</div>
          <Input clearable v-model="current_update_project_data.project_full_name" placeholder="输入项目名称"
            style="width: 400px" />
        </div>
        <div class="project_add_field">
          <div class="project_add_title">项目主体：</div>
          <Select clearable filterable v-model="current_update_project_data.subject_id" style="width: 400px">
            <Option v-for="item in subject_data" :value="item.subject_id" :key="item.subject_id">{{
              item.company_short_name
            }}
            </Option>
          </Select>
        </div>
        <div class="project_add_field">
          <div class="project_add_title">项目状态：</div>
          <Select clearable filterable v-model="current_update_project_data.operation_status" style="width: 400px">
            <Option v-for="item in operation_status_list" :value="item.value" :key="item.value">{{ item.label }}
            </Option>
          </Select>
        </div>

        <div class="project_add_field">
          <div class="project_add_title">部门：</div>
          <Cascader filterable :data="dep_options" v-model="current_update_project_data.dep_id_list" v-width="200" />
        </div>
      </div>
      <div class="button_add_project">
        <Button :loading="update_loading" type="primary" @click="update_project_ok">更新项目</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http } from "@/utils/http.js";
import project_auth from "@/views/project_manage/component/auth.vue";

export default {
  components: {
    my_menu2,
    project_auth,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      dep_options: [],
      select_dep: [],
      columns: [],
      project_list: [],
      page: 1,
      total_count: 0,
      limit: 20,
      table_loading: false,
      project_name: "",
      dep_list: [],

      group_data: [],
      add_project_show: false,
      add_group_project_id: "",
      add_type_id: 0,
      add_project_name: "",
      add_loading: false,

      type_options: [],

      update_project_show: false,
      current_update_project_data: {
        project_group_id: "",
        project_type: "",
        project_name: "",
        project_full_name: "",
        operation_status: 0,
      },
      update_loading: false,
      operation_status_index: -1,
      operation_status_list: [
        { label: "所有项目", value: -1 },
        { label: "正常项目", value: 0 },
        { label: "停止项目", value: 1 },
      ],

      group_list: [],
      update_group_show: false,
      current_project_item: {},
      update_project_group_id: "",

      subject_data: [],
      project_subject_id: "",

      kefu_name: '',
      project_auth_show: false
    };
  },

  mounted() {
    this.window_change();
    this.get_dep_list();
    this.get_project_options();
    this.get_project_type_options();
    this.get_group_data_list();
    this.get_subject_data();
    this.get_dep_options();
  },

  methods: {
    //获取部门选择器
    get_dep_options() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/create/dep_options",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.dep_options = res.data.dep_options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取主体数据
    get_subject_data() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/create/subject_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.subject_data = res.data.subject_data;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //确认更新项目组
    update_group_name_confirm() {
      var that = this;
      var obj = {
        project_id: this.current_project_item.project_id,
        project_group_id: this.update_project_group_id,
      };
      this.update_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/list/project_group_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_project_list();
            that.update_group_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.update_loading = false;
        })
        .catch((res) => {
          that.update_loading = false;

          console.log(res, "请求出错");
        });
    },

    editor_group(item) {
      this.current_project_item = item;
      this.update_group_show = true;
    },

    operation_status_change(e) {
      this.page = 1;
      this.get_project_list();
    },

    //更新新项目
    update_project_ok() {
      console.log(this.current_update_project_data);

      if (!this.current_update_project_data.project_id) {
        this.$Message.error("请选择项目id");
        return;
      }
      if (!this.current_update_project_data.project_group_id) {
        this.$Message.error("请选择项目组");
        return;
      }

      if (!this.current_update_project_data.project_name) {
        this.$Message.error("请选择项目简称");
        return;
      }
      if (!this.current_update_project_data.project_full_name) {
        this.$Message.error("请选择项目全称");
        return;
      }
      if (this.current_update_project_data.subject_id == "") {
        this.$Message.error("请选择项目主体");
        return;
      }
      if (this.current_update_project_data.dep_id_list.length != 2) {
        this.$Message.error("请选择项目部门");
        return;
      }

      var that = this;
      var obj = {
        project_id: this.current_update_project_data.project_id,
        project_group_id: this.current_update_project_data.project_group_id,
        project_name: this.current_update_project_data.project_name,
        project_full_name: this.current_update_project_data.project_full_name,
        project_type: this.current_update_project_data.project_type,
        operation_status: this.current_update_project_data.operation_status,
        subject_id: this.current_update_project_data.subject_id,
        dep_id: this.current_update_project_data.dep_id_list[1]
      };
      this.update_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/create/update_project",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_project_list();
            that.update_project_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.update_loading = false;
        })
        .catch((res) => {
          that.update_loading = false;

          console.log(res, "请求出错");
        });
    },

    update_project_click(item) {
      this.current_update_project_data = item;
      this.update_project_show = true;
    },

    //获取项目类型数据
    get_project_type_options() {
      var that = this;
      var obj = {
        project_name: this.add_project_name,
        project_group_id: this.add_group_project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/create/project_type_options",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.type_options = res.data.type_options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    //获取项目组数据
    get_project_options() {
      var that = this;
      var obj = {
        project_name: this.add_project_name,
        project_group_id: this.add_group_project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/create/group_options",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.group_data = res.data.group_data;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击添加项目
    click_add_project() {
      this.add_project_show = true;
    },

    //添加新项目
    add_project_ok() {
      if (!this.add_group_project_id) {
        this.$Message.error("请选择项目组");
        return;
      }
      // if (!this.add_type_id) {
      //     this.$Message.error('请选择项目类型')
      //     return

      // }

      if (this.dep_list.length != 2) {
        this.$Message.error("请选择部门");
        return;
      }

      if (!this.add_project_name) {
        this.$Message.error("请选择项目名称");
        return;
      }

      if (this.project_subject_id == "") {
        this.$Message.error("请选择项目主体");
        return;
      }

      var that = this;
      var obj = {
        project_group_id: this.add_group_project_id,
        project_name: this.add_project_name,
        project_type: this.add_type_id,
        subject_id: this.project_subject_id,
        dep_id: this.dep_list[1],
      };
      this.add_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/create/create_project",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_project_list();
            that.add_project_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.add_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    search() {
      this.get_group_data_list();

      this.page = 1;
      this.get_project_list();
    },

    cascader_change(e) {
      this.select_dep = e;
      this.page = 1;
      this.get_project_list();
    },

    page_change(e) {
      this.page = e;
      this.get_project_list();
    },

    click_project_manage(item) {
      this.project_auth_show = true
      this.$refs.project_auth.open(item.project_id);
    },

    //获取部门列表
    get_project_list() {
      var that = this;
      var obj = {
        dep_id_list: this.select_dep,
        page: this.page,
        project_name: this.project_name,
        operation_status: this.operation_status_index,
        kefu_name: this.kefu_name
      };
      this.table_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/list/project_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.project_list = res.data.project_list;

            that.total_count = res.data.total_count;
            that.limit = res.data.limit;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取部门列表
    get_dep_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/list/dep_options",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.dep_options = res.data.dep_options;
            // that.select_dep = [res.data.dep_options[0]['value'], res.data.dep_options[0]['children'][0]['value']]
            that.get_project_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 获取项目组数据
    get_group_data_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/list/project_group_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.group_list = res.data.group_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.editor_group_name {
  font-size: 16px;
  margin-left: 5px;
  cursor: pointer;
}

.operation_status_span2 {
  background-color: #eb1906;
  color: #fff;
  padding: 1px 3px;
  border-radius: 3px;
}

.operation_status_span {
  background-color: #00cd66;
  color: #fff;
  padding: 1px 3px;
  border-radius: 3px;
}

.editor_group_class {
  margin-left: 3px;
  font-size: 14px;
}

.editor_group_class:hover {
  color: #0466dd;
  cursor: pointer;
}

.project_name {
  display: flex;
  align-items: center;
}

.project_name2 {
  cursor: pointer;
}

.project_name2:hover {
  color: #0466dd;
}

.project_type_name {
  flex-shrink: 0;
  margin-right: 5px;
  padding: 0 3px;
  border-radius: 3px;
  background-color: #23ad61c6;
  font-size: 10px;
  color: #fff;
}

.button_add_project {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.add_project_box {
  position: relative;
}

.project_add_title {
  width: 100px;
  flex-shrink: 0;
}

.project_add_field {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.options_inner {
  display: flex;
  align-items: center;
}

.page_div {
  text-align: center;
  padding-top: 5px;
}

.options_div {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.select_title {
  width: 100px;
  flex-shrink: 0;
}

.select_item {
  display: flex;
  align-items: center;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  background-color: #fff;
  padding: 10px;
  height: calc(100vh - 40px);
  overflow: auto;
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
}
</style>
